import React from "react";
import styled from "styled-components";
import { NewModuleSetting, UpdatedModuleSetting } from "@models";
import { Currency } from "@util/formatting";

export default function ModuleSettingAmountsSummary(props: {
	moduleSetting: UpdatedModuleSetting | NewModuleSetting;
}) {
	const amount = getAmountSums(props.moduleSetting);
	return (
		<>
			<Amount title="Monatliches Budget">
				{Currency.format(amount.monthly, { hideZeroDecimals: true })}
			</Amount>
			{amount.daily && (
				<Amount secondary title="Tägliches Budget">
					{Currency.format(amount.daily, { hideZeroDecimals: true })} / Tag
				</Amount>
			)}
			{props.moduleSetting.initialCorrectionAmount !== null && (
				<Amount secondary title="Einmaliger Korrekturwert">
					{props.moduleSetting.initialCorrectionAmount > 0 ? "+" : ""}
					{Currency.format(props.moduleSetting.initialCorrectionAmount, {
						hideZeroDecimals: true,
					})}
				</Amount>
			)}
		</>
	);
}

const Amount = styled.div`
	font-size: ${(props: { secondary?: boolean }) =>
		props.secondary ? "1.1rem" : "1.5rem"};
`;

function getAmountSums(moduleSetting: UpdatedModuleSetting | NewModuleSetting) {
	return moduleSetting.amounts.reduce<{
		monthly: number;
		daily: number | undefined;
	}>(
		(sum, curr) => {
			return {
				monthly: sum.monthly + curr.maxAmountMonth,
				daily: curr.maxAmountDay
					? (sum.daily ?? 0) + curr.maxAmountDay
					: sum.daily,
			};
		},
		{ monthly: 0, daily: undefined }
	);
}
